// extracted by mini-css-extract-plugin
module.exports =  {"errorPage":"P23km3JT2bb8DhEHaKP1","heading":"tt6L_vtosw3J3jdUZtP3"};